
import React from 'react'

const Dashboard = () => {
  return (
    <div>
      Home page
    </div>
  )
}

export default Dashboard
